export const getParams = (key?: string, url = location.href) => {
	const urlObject = new URL(url);
	const params = Object.fromEntries(new URLSearchParams(urlObject.search));
	return key
		? params[key]
		: Object.entries(params).reduce((allParams, [_key, value]) => {
				try {
					allParams[_key] = JSON.parse(value);
				} catch {
					// value is not a serialized JSON
					allParams[_key] = value;
				}
				return allParams;
		  }, params);
};

export const replaceParams = (
	params: Record<string, string> = {},
	updateHistory = false,
	url = location.href
) => {
	const urlObject = new URL(url);
	const search = new URLSearchParams(urlObject.search);

	Object.entries(params).forEach(([key, value]) => search.set(key, value));
	urlObject.search = search.toString();

	const newURL = urlObject.toString();

	if (updateHistory) {
		history.pushState(null, '', newURL);
	}

	return newURL;
};
